import {
  buildFooterPublicationUrl,
  FOOTER_NEWS_PUBLICATIONS,
} from "@config/FooterConstants";
import React from "react";
import { Link } from "react-router";

const FooterNewsPublication = (): React.ReactElement => {
  const newsPublications = FOOTER_NEWS_PUBLICATIONS.map((item) => ({
    ...item,
    to: buildFooterPublicationUrl(item.url),
  }));

  return (
    <div
      className="flex flex-col text-2sm"
      data-testid="footer-newsPublications"
    >
      <p className="text-gray-100">SPH Media வெளியிடும் வெளியீடுகள்</p>
      <div className="flex flex-wrap">
        {newsPublications.map(({ title, target, to }, index) => (
          <React.Fragment key={title}>
            <Link
              key={title}
              to={to}
              target={target}
              rel="noopener noreferrer"
              className="text-red-100 hover:text-red-200 hover:underline"
            >
              {title}
            </Link>
            {index < newsPublications.length - 1 && (
              <span className="text-gray-100">&nbsp;|&nbsp;</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default FooterNewsPublication;
